module.exports = __webpack_public_path__ + "static/media/bookmark_solid.99ff0185.svg";